import React from 'react';
import { Box } from '@mui/system';
import { StyledMe2onProduct } from './styles';

export type IMe2onProductProps = {
  productImage: string;
  quantityDisplay: string;
  isMainProduct: boolean;
  textColor: string;
  strokedSaleQuantity?: string;
};

export const Me2onProduct: React.FC<IMe2onProductProps> = ({
  productImage,
  quantityDisplay,
  isMainProduct,
  textColor,
  strokedSaleQuantity = '',
}) => {
  return (
    <StyledMe2onProduct textColor={textColor}>
      <Box className="product-container">
        <img
          src={productImage}
          alt="product"
          className="product-container--image"
        />
      </Box>
      <Box className="product-amount">{`${quantityDisplay} chips`}</Box>
      {isMainProduct && <p className="stroked">{strokedSaleQuantity}</p>}
    </StyledMe2onProduct>
  );
};
